import { render, staticRenderFns } from "./ShipmentCustomFieldModal.vue?vue&type=template&id=7e459b0f&scoped=true&"
import script from "./ShipmentCustomFieldModal.vue?vue&type=script&lang=js&"
export * from "./ShipmentCustomFieldModal.vue?vue&type=script&lang=js&"
import style0 from "./ShipmentCustomFieldModal.vue?vue&type=style&index=0&id=7e459b0f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e459b0f",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\source\\locate2u-server\\Locate2u.AppPortal\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7e459b0f')) {
      api.createRecord('7e459b0f', component.options)
    } else {
      api.reload('7e459b0f', component.options)
    }
    module.hot.accept("./ShipmentCustomFieldModal.vue?vue&type=template&id=7e459b0f&scoped=true&", function () {
      api.rerender('7e459b0f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/TeamSettings/BookingFields/components/ShipmentCustomFieldModal.vue"
export default component.exports